exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.dragArea[data-v-aead3c14] {\r\n  min-height: 50px;\r\n  outline: 1px solid #e1e1e1;\n}\r\n\r\n", ""]);

// exports
